import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { EvaluacionCuestionarioDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EvaluacionCuestionarioService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEvaluacionCuestionarioService(): Observable<BodyListResponse<EvaluacionCuestionarioDTO>> {
    return this.http.get<BodyListResponse<EvaluacionCuestionarioDTO>>(API_URL + '/api/v1/evaluacionCuestionario/todos');
  }

  guardarEvaluacionCuestionarioService(evaluacionCuestionarioDTO: EvaluacionCuestionarioDTO): Observable<BodyResponse<EvaluacionCuestionarioDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/evaluacionCuestionario', evaluacionCuestionarioDTO);
  }

  getEvaluacionCuestionarioPorCodigoService(codigo: string): Observable<BodyResponse<EvaluacionCuestionarioDTO>> {
    return this.http.get<BodyResponse<EvaluacionCuestionarioDTO>>(API_URL + '/api/v1/evaluacionCuestionario/' + codigo);
  }

  getEvaluacionCuestionarioTipoProcesoService(codigo: string): Observable<BodyListResponse<EvaluacionCuestionarioDTO>> {
    return this.http.get<BodyListResponse<EvaluacionCuestionarioDTO>>(API_URL + '/api/v1/evaluacionCuestionario/tipoProceso/'+codigo);
  }

}
